<template>
  <v-container>
    <v-layout>
      <v-flex>
        <p>{{$tf('NoDownloadableBody.intro')}}</p>
        <a @click="()=>{showMore = !showMore}">{{!showMore?$tf('MoreInfo') + '...':$tf('Hide')}}</a>
        <v-card-text v-show="showMore">
        <p>{{$tf('NoDownloadableBody.explanation.header')}}</p>
        <ul style="padding-left: 50px; padding-bottom: 10px">
          <li>{{$tf('NoDownloadableBody.explanation.cause1', {'limit':limits.maxDocuments})}}</li>
          <li>{{$tf('NoDownloadableBody.explanation.cause3', {'limit':limits.maxStudies})}}</li>
          <li>{{$tf('NoDownloadableBody.explanation.cause4', {'limit': Math.round(limits.maxSize /1000000)})}}</li>
        </ul>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'no-downloadable',
    props: {
      limits: {
        type: Object,
        default: () => ({})
      },
      description: { // TODO be more informative about what is wrong
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        showMore: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  img {
    max-height: 28px;
  }
  span
  {
    white-space: pre;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogNoDownloadable.vue